module.exports = __webpack_public_path__ + "static/media/a46.a6325ec1.jpg";